import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=e08c1490&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=e08c1490&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08c1490",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e08c1490')) {
      api.createRecord('e08c1490', component.options)
    } else {
      api.reload('e08c1490', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=e08c1490&scoped=true", function () {
      api.rerender('e08c1490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/vocational-evaluation/tabs/one-part-b/Main.vue"
export default component.exports